/* eslint-disable no-console */
import { toastr } from "react-redux-toastr";
import { useAxiosPost, useAxiosGet } from "@axios";

export const registerBusinessClient = async (form, resetForm, setLoading) => {
  try {
    setLoading?.(true);
    const response = await useAxiosPost("/business_client/register", form);
    if (response?.data?.success) {
      toastr.success("Success", response.data.message);
      resetForm?.();
    } else {
      toastr.error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.log("Error in registerBusinessClient: ", error);
  }
  setLoading?.(false);
};

export const fetchBusinessClientNames = async (setLoading) => {
  try {
    setLoading?.(true);
    const response = await useAxiosGet("/business_client/client_details");
    if (response?.data?.success) {
      return response?.data?.result;
    } else {
      toastr.error(response?.data?.message || "Something went wrong");
      return [];
    }
  } catch (error) {
    console.log("Error in fetchBusinessClientNames: ", error);
    return [];
  } finally {
    setLoading?.(false);
  }
};
